// extracted by mini-css-extract-plugin
export default {"customStyle":"LanguageSwitcher_customStyle__dVjjt","absolute":"LanguageSwitcher_absolute__0Ag7F","flag":"LanguageSwitcher_flag__IptVs"};